/**
 * Created by rhett on 2019/4/15.
 */

import React, {Component} from 'react';


export default class ScrollTop extends Component
{


  componentDidMount()
  {
  }


  componentDidUpdate(prevProps)
  {
    if (this.props.location !== prevProps.location)
    {
      setTimeout( window.scrollTo,100,0,0);
    }
  }

  render()
  {
    return this.props.children;
  }

}